/**
 * 공용 접힘/펼침 화살표 — 펼침 시 180도 회전.
 * AI 화면 전체의 화살표 시각 언어를 하나로 통일한다
 * (기존에는 글리프 ▾ 11px / MUI 아이콘 14·15·16·18px 이 혼재했다).
 *
 * @param {boolean} open  펼침 여부 (true면 180도 회전)
 * @param {string}  color 아이콘 색 (기본 C.text3). 카드 톤에 맞춰 오버라이드
 * @param {number|string} ml 좌측 마진 (sx 값). 우측 정렬이 필요하면 "auto"
 */
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { C } from "@plannel/components/ai/aiTokens";

export function CollapseArrow({ open, color = C.text3, ml }) {
  return (
    <ExpandMoreIcon aria-hidden sx={{ flex: "0 0 auto", ml, color, fontSize: 18,
      transform: open ? "rotate(180deg)" : "none", transition: "transform .15s" }} />
  );
}

export default CollapseArrow;
